module.exports = __webpack_public_path__ + "components/accordion-reviews/static/icon-caret-down-b0066d16e4ba2a69036abc5e88f8d069.svg";